import React from "react";
import { useContainer } from "unstated-next";
import Message from "../../../store/message";
import Alert from "./Alert";

const AlertToast: React.FC = (props) => {
  const { messages, deleteMessage, clearMessages } = useContainer(Message);

  return (
    <div className="alertContainer">
      {messages.map((msg) => (
        <Alert key={msg.id} message={msg.message} type={msg.type} onClear={() => deleteMessage(msg)} />
      ))}
      {messages.length > 5 && (
        <p className="clearAlert defaultText text-xs text-center cursor-pointer" onClick={clearMessages}>
          Clear notifications
        </p>
      )}
    </div>
  );
};

export default AlertToast;
